import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Conclusionfsk() {
  return (
    <div className="conclusion_fsk p-100">
      <Container>
        <div className="conc_red_img">
          <StaticImage
            src="../../../images/case-studies/fsk/result-red.webp"
            alt="TekRevol"
            layout="constrained"
            placeholder="blurred"
            formats={["png"]}
            width={192}
            height={194}
          />
        </div>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="text-center m-auto"
          >
            <h2>
              <span>Conclusion</span>
            </h2>
            <p>
              The collaboration between TekRevol and the client for "FSK"
              exemplifies a successful fusion of creativity, strategy, and
              storytelling in mobile gaming. This project showcases TekRevol's
              innovation in pushing the boundaries of mobile gaming, meeting and
              surpassing player expectations. "FSK" caters to a diverse
              audience, resonating with puzzle enthusiasts, time management
              fans, and lovers of role-playing narratives. The game's strategic
              impact extends beyond entertainment, emphasizing the potential for
              well-executed, creatively designed mobile games to make a lasting
              impact in the competitive gaming industry. In summary, "FSK"
              represents a milestone in mobile gaming, reflecting TekRevol's
              commitment to delivering innovative and engaging solutions and
              establishing itself as a noteworthy player in the dynamicl and
              scape of mobile gaming.  
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="text-center m-auto"
          >
            <div className="conc_img">
              <StaticImage
                src="../../../images/case-studies/fsk/conclusion.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1506}
                height={539}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Conclusionfsk;
